import LoggingList from "./LoggingList";
import LoggingIcon from '@mui/icons-material/EmojiPeopleTwoTone';

export default {
    list: LoggingList,
    icon: LoggingIcon
}